import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import './MartHome.css'; 

const MART_API_BASE = 'https://api.atrmart.in/martapi';

const subCategoryIconMap = {
  'mens-western-wear': '👔', 
  'mens-ethnic-wear': '🥻', 
  'womens-western-wear': '👗', 
  'womens-ethnic-wear': '💃', 
  'kids-wear': '👶', 
  'winter-outerwear': '🧥', 
  'innerwear-sleepwear': '🩳',
  'all-mobile-phones': '📱', 
  'mobile-accessories': '🔌', 
  'laptops-computers': '💻', 
  'headphones-audio': '🎧', 
  'smart-watches-wearables': '⌚', 
  'televisions-projectors': '📺', 
  'cameras-accessories': '📷', 
  'storage-devices': '💾',
  'kitchen-dining': '🍽️', 
  'home-furnishings': '🛏️', 
  'home-decor-lighting': '💡', 
  'home-furniture': '🛋️', 
  'home-improvement-tools': '🛠️', 
  'pet-supplies': '🐾',
  'daily-groceries-staples': '🌾', 
  'snacks-packaged-foods': '🍿', 
  'beverages': '☕', 
  'spices-cooking-oils': '🌶️', 
  'dairy-bakery': '🧀', 
  'household-supplies': '🧹',
  'makeup-cosmetics': '💄', 
  'skin-hair-care': '🧴', 
  'fragrances-perfumes': '🧪', 
  'personal-grooming-appliances': '🪮', 
  'health-supplements-vitamins': '💊', 
  'oral-personal-hygiene': '🪥',
  'deal-of-the-day': '🔥', 
  'clearance-sale': '🚨', 
  'combo-offers': '🎁', 
  'festival-seasonal-discounts': '🎉'
};

const MartSubCategories = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const searchParams = new URLSearchParams(location.search);
  const categoryId = location.state?.categoryId || searchParams.get('id');
  const categoryName = location.state?.categoryName || searchParams.get('name') || 'Categories';
  
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSubCategories = useCallback(async () => {
    if (!categoryId) return;
    setLoading(true);
    try {
      const response = await axios.get(`${MART_API_BASE}/subcategories`, {
        params: { category_id: categoryId }
      });
      
      // Safety Check: Extracts array from any common Laravel endpoint formats
      let extractedData = [];
      if (response.data) {
        if (Array.isArray(response.data)) {
          extractedData = response.data;
        } else if (Array.isArray(response.data.data)) {
          extractedData = response.data.data;
        } else if (Array.isArray(response.data.sub_categories)) {
          extractedData = response.data.sub_categories;
        }
      }
      
      setSubCategories(extractedData);
    } catch (err) {
      console.error("Error fetching subcategories data tier:", err);
      setSubCategories([]);
    } finally {
      setLoading(false);
    }
  }, [categoryId]);

  useEffect(() => {
    if (!categoryId) {
      navigate('/mart');
    } else {
      fetchSubCategories();
    }
  }, [categoryId, fetchSubCategories, navigate]);

  return (
    <div className="mart-dashboard-wrapper">
      <header className="mart-header-main">
        <div className="mart-container-flex">
          <div className="mart-logo-bold" onClick={() => navigate('/mart')}>
            <h1>ATR <span>MART</span></h1>
          </div>
          <nav className="mart-header-nav-links">
            <span onClick={() => navigate('/mart')}>Home</span>
            <span className="active-nav" onClick={() => navigate('/mart')}>Categories</span>
          </nav>
          <button className="m-login-btn" onClick={() => navigate('/mart')}>← Back Home</button>
        </div>
      </header>

      <main className="mart-main-body" style={{ minHeight: '70vh', padding: '40px 20px' }}>
        <div className="section-title-wrap">
          <h2 style={{ textTransform: 'uppercase', letterSpacing: '1px' }}>
            Explore {decodeURIComponent(categoryName)} Subcategories
          </h2>
          <div className="divider" style={{ width: '120px', height: '3px', background: '#00f2fe' }}></div>
        </div>

        {loading ? (
          <div className="mart-loader">
            <div className="spinner-glow"></div>
            <span>Categorizing Inventory Layers...</span>
          </div>
        ) : (
          <div className="mart-categories-render-grid" style={{ marginTop: '40px', display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}>
            {subCategories.length > 0 ? (
              subCategories.map(sub => {
                const subIcon = subCategoryIconMap[sub.slug] || '📁';
                return (
                  <div 
                    key={sub.id}
                    onClick={() => navigate(`/martproducts?id=${categoryId}&name=${encodeURIComponent(categoryName)}&sub_id=${sub.id}&sub_name=${encodeURIComponent(sub.name)}`)}
                    className="premium-category-morphic-card"
                    style={{ minHeight: '140px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', cursor: 'pointer', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px', background: '#ffffff' }}
                  >
                    <div className="morphic-icon-wrapper" style={{ fontSize: '2.5rem', marginBottom: '12px' }}>
                      {subIcon}
                    </div>
                    <span className="morphic-title-text" style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1e293b' }}>
                      {sub.name}
                    </span>
                  </div>
                );
              })
            ) : (
              <div className="mart-empty-state" style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px' }}>
                <span className="empty-box-emoji" style={{ fontSize: '3rem' }}>📂</span>
                <p style={{ marginTop: '15px', color: '#64748b', fontWeight: '500' }}>No explicit sub-tiers found in the database for this section.</p>
              </div>
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default MartSubCategories;